/**
 * A validação de forma do click id, isolada do leitor.
 *
 * Mora em módulo próprio por uma razão estrutural: `click-id.ts` (o leitor) e `click-id-store.ts` (a
 * persistência de sessão) precisam dos dois da mesma regra, e o leitor importa o store — se o store
 * importasse o leitor de volta, os dois formariam ciclo. É a mesma disciplina que mantém
 * `configs/sdk.ts` importando `click-id.ts` e nunca o contrário.
 */

// Mesma linha de defesa do `sanitizeUTM` em `src/utils/sanitize-utm.ts`: tudo aqui vem da URL, de um
// cookie ou do sessionStorage — todos controláveis por quem visita. Um `?clickId=<lixo>` de crawler
// colocaria `/plans` na rota que é throttled por IP (ver `src/store/plan.tsx`).
const CLICK_ID_MAX_LENGTH = 128;
const CLICK_ID_PATTERN = /^[A-Za-z0-9_-]+$/;

/**
 * Um click id que estamos dispostos a enviar, ou `undefined`.
 *
 * Rejeita em vez de aparar: um click id com um caractere removido é um click id DIFERENTE, e mandar o
 * errado é pior do que não mandar nenhum — a API responderia "sem campanha" do mesmo jeito, mas a
 * requisição ainda seria a throttled.
 */
export function sanitizeClickId(value: unknown): string | undefined {
  if (typeof value !== 'string') return undefined;

  const clickId = value.trim();

  if (!clickId || clickId.length > CLICK_ID_MAX_LENGTH || !CLICK_ID_PATTERN.test(clickId)) return undefined;

  return clickId;
}
